import { render, staticRenderFns } from "./PartnerDeals.vue?vue&type=template&id=28df0121&scoped=true"
import script from "./PartnerDeals.vue?vue&type=script&lang=js"
export * from "./PartnerDeals.vue?vue&type=script&lang=js"
import style0 from "./PartnerDeals.vue?vue&type=style&index=0&id=28df0121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28df0121",
  null
  
)

export default component.exports